import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AppWrapper from '../../shared/appWrapper';
import CityView from './components/city-view';
import AccommodationView from './components/accomodation-view';
import TripInfoView from './components/tripInfo-view';
import { FetchIntineraries } from '../../../actions/itineraries';
import Spinner from '../../shared/spinner';
import { sectorWithImagesAndInfo } from '../../../helpers/cyoaHelper';
const queryString = require('query-string');
const qs = queryString.parse(window.location.search);


class City extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      cityActive:false,
      accommodationActive:false,
      tripInfoActive:true
    }
    this.toggleViews = this.toggleViews.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
  }

  onBackClicked(){

    const {
      history
    } = this.props;

    history.push(`${process.env.REACT_APP_ITINERARY_PAGE}?id=${qs.id}`);

  }

  componentDidMount(){

    const {
      FetchIntineraries,
      itineraries
    } = this.props;

    // Scroll window to top
    window.scrollTo(0, 0);

    //FetchIntineraries
    if(itineraries === undefined) FetchIntineraries(qs.id);

  }

  toggleViews(view){
    switch (view) {
      case 'city':
        this.setState({cityActive:true, accommodationActive:false, tripInfoActive:false});
        break;
      case 'accommodation':
        this.setState({cityActive:false, accommodationActive:true, tripInfoActive:false});
        break;
      case 'tripInfo':
        this.setState({cityActive:false, accommodationActive:false, tripInfoActive:true});
        break;
      default:
        this.setState({cityActive:true, accommodationActive:false, tripInfoActive:false});
    }
  }


  render(){

    const { cityActive, accommodationActive, tripInfoActive } = this.state;
    const { itineraries } = this.props;
    const _itineraries = (itineraries !== undefined && Object.keys(itineraries).length > 0) ? itineraries : [];

    if(_itineraries.length === 0){
      return <Spinner text="Loading your adventure..." loadClass="orange-spinner-wrapper" />
    }else{

      const qs = queryString.parse(window.location.search);
      const { itineraries, itineraries:{sectors, cities} } = this.props;

      return (
        <AppWrapper className="city">
        <button className="lity-close" onClick={this.onBackClicked}>×</button>
          <div className="row text-center margin-t-70">
            <div className="column small-12">
              <ul className="details-menu">
                <li onClick={e => this.toggleViews('tripInfo')} className={`${tripInfoActive ? 'active' : ''} `}>Trip Info</li>
                <li onClick={e => this.toggleViews('accommodation')} className={`${accommodationActive  ? 'active' : ''}`}>Accommodation</li>
                <li onClick={e => this.toggleViews('city')} className={`${cityActive  ? 'active' : ''}`}>City Info</li>
              </ul>
            </div>
          </div>


          <div className="row margin-t-50">
            <div className="column small-12">
              { cityActive && <CityView index={parseInt(qs.index, 10)} sectors={sectors} cities={cities} active={qs.name} /> }
              { accommodationActive && <AccommodationView index={parseInt(qs.index, 10)} cities={cities} sectors={sectors} active={qs.name} /> }
              { tripInfoActive && <TripInfoView index={parseInt(qs.index, 10)} sectors={sectorWithImagesAndInfo(itineraries)} cities={cities} active={qs.name} /> }
            </div>
          </div>

        </AppWrapper>
      )
    }
  }
}

function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchIntineraries
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(City);



// WEBPACK FOOTER //
// ./src/components/itinerary/city/index.js